import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { payPlanMobx } from '@mobxStore'

interface IProps {
  option: IPercentTipOption;
  onSelected?: () => void;
}

const PercentTipItem: FC<IProps> = ({ option, onSelected }) => {
  const selected = payPlanMobx.selectedTipOption?.type === 'percent' &&
    payPlanMobx.selectedTipOption?.percent === option.percent

  const onClick = () => {
    payPlanMobx.selectTipOption(option)
    onSelected && onSelected()
  }

  return (
    <li className={classNames('select-tip-item', { selected })} data-cypid='percentTipItem' onClick={onClick}>
      <span className='amount'>{format.toPrice(option.amount)}</span>
      <span className='percent'>{format.toPercent(option.percent)}</span>
      <i className={classNames('iconfont', selected ? 'icon-checked' : 'icon-circle')} />
    </li>
  )
}

export default observer(PercentTipItem)
